/* or-other:
 *
 * Do stuff with 'other' option
 *
 * Author: Niels Giesen
 * Copyright 2015 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  var _selector = ".bbm-radiogroup-or-other";

  $(function () {
    $(doc).on(
      "click keypress",
      'input[type="text"]' + _selector + ", textarea" + _selector,
      function (ev) {
        $(this)
          .parents(".bb-option")
          .find('input[type="radio"]')
          .prop("checked", true)
          .trigger("change");
        ev.stopPropagation();
      }
    );

    $(doc).on("change", _selector + ' [type="radio"]', function (ev) {
      $(this)
        .parents(".bb-option")
        .find('input[type="text"], textarea')
        .focus();
    });

    $(doc).on("bb:postHandleData", function (event, data) {
      if (data && data.groups)
        $(".bb-g-radiogroup-or-other").each(function () {
          var $this = $(this),
            $otheritem = $this.find(".bb-option:last-of-type"),
            $nextgroup,
            $otherinput;
          if ($otheritem.length) {
            $nextgroup = $this.next();
            $otherinput = $nextgroup.find(
              "input.bbm-radiogroup-or-other," +
                " textarea.bbm-radiogroup-or-other"
            );
            if (
              $otherinput.is("textarea") &&
              $otherinput.parents(".xarea").length
            ) {
              $otherinput = $otherinput.parents(".xarea");
            }
            $otheritem.append($otherinput);
            $nextgroup.hide();
          }
        });
    });
  });
})(jQuery, window, document);
